import * as React from 'react';

export interface GridProps {
  gridCols?: string | number;
  gridRows?: string | number;
  rowGap?: string;
  colGap?: string;
  items?: string;
  justify?: string;
  className?: string;
}

const Grid: React.FC<GridProps> = ({ gridCols, gridRows, rowGap, colGap, items, justify, className, children }) => {
  const gridTemplate = (direction: string | number | undefined) =>
    typeof direction === 'string' ? direction : `repeat(${direction}, 1fr)`;
  return (
    <div
      className={`w-full grid items-${items} justify-${justify} ${className}`}
      style={{
        gridTemplateColumns: gridTemplate(gridCols),
        gridTemplateRows: gridTemplate(gridRows),
        columnGap: colGap,
        rowGap: rowGap
      }}
    >
      {children}
    </div>
  );
};

export default Grid;
